import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Network, ShieldAlert, UserX } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
const problems = [{
  icon: Clock,
  title: 'Small issues become billable-time disruption',
  body: 'Slow support affects client work, deadlines, productivity and revenue.'
}, {
  icon: Network,
  title: 'Too many vendors, no clear owner',
  body: 'Software, cloud, phones and security providers point at one another while your team coordinates the fix.'
}, {
  icon: ShieldAlert,
  title: 'Security feels separate from daily IT',
  body: 'Controls are added reactively, leaving uncertainty around client data, continuity and commercial risk.'
}, {
  icon: UserX,
  title: 'The provider does not understand the firm',
  body: 'Generic advice ignores practice systems, fee-earner workflows, reporting periods and the urgency professional services demand.'
}];
export function BuyerPain() {
  return <Section className="bg-white" ariaLabel="The problem beneath the technology" data-id="element-139">
      <SectionHeading eyebrow="The problem beneath the technology" eyebrowColor="var(--svc-red)" title="Your firm should not have to chase its IT provider." body="Professional firms need attention, urgency and clear ownership — not tickets that disappear into a queue, vendors pointing at one another or another tool added without a plan." data-id="element-140" />

      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5" data-id="element-141">
        {problems.map((p, i) => <motion.div key={p.title} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: i * 0.06
      }} className="group flex gap-5 rounded-card border border-border bg-white p-6 shadow-sm transition-all duration-300 ease-smooth hover:-translate-y-1 hover:shadow-md" data-id="element-142">
            <div className="flex flex-col items-center gap-3" data-id="element-143">
              <span className="font-display text-[15px] font-black tabular-nums text-security/40" data-id="element-144">
                0{i + 1}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-security/8 ring-1 ring-security/15" data-id="element-145">
                <p.icon className="h-5 w-5 text-security" aria-hidden data-id="element-146" />
              </span>
            </div>
            <div data-id="element-147">
              <h3 className="font-display text-[18px] font-bold leading-snug text-navy" data-id="element-148">
                {p.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-slate" data-id="element-149">
                {p.body}
              </p>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-8 flex items-center justify-center rounded-panel bg-navy px-7 py-8 text-center shadow-md md:px-10" data-id="element-150">
        <p className="font-display text-[21px] font-black leading-snug text-white md:text-[26px]" data-id="element-151">
          CT Group brings the environment together and{' '}
          <span className="text-ct-light" data-id="element-152">owns the outcome.</span>
        </p>
      </div>
    </Section>;
}